"use client";

import { Button } from "antd";
import Image from "next/image";
import { useState } from "react";
import chevronDown from "@/public/icon/chevron-down.png";
import styles from "../../app/blog/review-nha-khoa/page.module.scss";

const ReviewClinicIntro = () => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className={styles.wpIntro}>
      <h1 className={styles.title}>
        Review Nha Khoa – Cẩm nang lựa chọn phòng khám uy tín
      </h1>
      <div
        className={`${styles.description} ${
          expanded ? styles.unhideDescription : ""
        }`}
      >
        <p>
          Giữa hàng ngàn phòng khám nha khoa mọc lên tại các thành phố lớn và
          tỉnh thành trên khắp cả nước, việc lựa chọn một địa chỉ uy tín, chất
          lượng và phù hợp là điều không hề dễ dàng với nhiều người. Hiểu được
          điều đó, Blog Review Nha Khoa ra đời với mục tiêu trở thành cẩm nang
          đáng tin cậy dành cho những ai đang tìm kiếm một nơi chăm sóc răng
          miệng tốt, an toàn và phù hợp với nhu cầu cá nhân.
        </p>
        <p>
          Trang Review Nha Khoa chuyên tổng hợp, phân tích và chia sẻ các bài
          viết đánh giá chi tiết về nhiều phòng khám nha khoa trên toàn quốc, từ
          các hệ thống lớn đến phòng khám tư nhân quy mô nhỏ. Nội dung bài viết
          được xây dựng dựa trên trải nghiệm thực tế, ý kiến của người dùng và
          thông tin minh bạch từ phía phòng khám. Đặc biệt, mỗi bài review đều
          tập trung vào các yếu tố mà người bệnh quan tâm nhất như:
        </p>
        <ul>
          <li>Tay nghề và thái độ của đội ngũ bác sĩ</li>
          <li>Trang thiết bị – máy móc hiện đại hay không</li>
          <li>Không gian phòng khám có sạch sẽ, chuyên nghiệp</li>
          <li>Giá cả có minh bạch, hợp lý so với thị trường</li>
          <li>
            Các phản hồi tích cực/tiêu cực từ khách hàng đã sử dụng dịch vụ
          </li>
        </ul>
        <p>
          Với tiêu chí “Chia sẻ thật – Trải nghiệm thật”, Blog Review Nha Khoa
          hướng tới mục tiêu mang đến thông tin chính xác, minh bạch và có giá
          trị thực tế cao cho người đọc. Đội ngũ biên tập luôn cố gắng cập nhật
          các địa chỉ mới, kiểm chứng thông tin thường xuyên để đảm bảo mọi bài
          viết đều đáng tin cậy. Dù bạn là người lần đầu đi khám răng hay đang
          tìm kiếm dịch vụ chuyên sâu hơn, Blog Review Nha Khoa chắc chắn sẽ là
          người bạn đồng hành lý tưởng, giúp bạn an tâm hơn trong hành trình bảo
          vệ nụ cười.
        </p>
      </div>
      <Button
        className={styles.btnLoadmore}
        type="link"
        onClick={() => setExpanded((prev) => !prev)}
        icon={
          <Image
            src={chevronDown}
            width={13}
            height={13}
            style={{
              transform: `rotate(${expanded ? -90 : 90}deg)`,
              transition: "transform 0.3s ease",
              display: "flex",
            }}
          />
        }
        iconPosition="end"
      >
        {expanded ? "Thu gọn" : "Xem thêm"}
      </Button>
    </div>
  );
};

export default ReviewClinicIntro;
